import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, MailCheck } from 'lucide-react';
import { api, ApiError } from '@/lib/api';
import { Alert, Button, Field, Input } from '@/components/ui';
import { AuthCard } from './AuthCard';

export default function PasswortVergessenPage() {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const r = await api.post<{ message: string }>('/auth/forgot-password', { email });
      setDone(r.message);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Die Anfrage konnte nicht gesendet werden.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthCard title="Passwort vergessen" subtitle={done ? undefined : 'Geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Link, mit dem Sie ein neues Passwort festlegen.'}>
      {done ? (
        <div className="space-y-4">
          <Alert tone="success" title="E-Mail unterwegs">
            {done} Der Link ist 60 Minuten gültig. Bitte prüfen Sie auch den Spam-Ordner.
          </Alert>
          <p className="flex items-center gap-2 text-sm text-slate-500">
            <MailCheck className="h-4 w-4" /> Keine E-Mail erhalten? Wenden Sie sich an Ihre Verwaltung bzw. den Administrator.
          </p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          {error && <Alert tone="error">{error}</Alert>}
          <Field label="E-Mail-Adresse" htmlFor="email">
            <div className="relative">
              <Mail className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
              <Input id="email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} className="pl-9" autoFocus />
            </div>
          </Field>
          <Button type="submit" variant="primary" className="w-full" loading={busy}>
            Link anfordern
          </Button>
        </form>
      )}
      <Link to="/login" className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-brand-700 hover:underline">
        <ArrowLeft className="h-4 w-4" /> Zur Anmeldung
      </Link>
    </AuthCard>
  );
}
